import gql from 'graphql-tag';

const GET_USERS = gql`
	{
		users {
			id
			email
			client_name
			client_address
			contact_firstname
			contact_lastname
			fonction
			telephone
		}
	}
`;

const CREATE_USER = gql`
	mutation(
		$email: String!
		$client_name: String!
		$client_address: String!
		$contact_firstname: String!
		$contact_lastname: String!
		$fonction: String!
		$telephone: String!
	) {
		user: createUser(
			email: $email
			client_name: $client_name
			client_address: $client_address
			contact_firstname: $contact_firstname
			contact_lastname: $contact_lastname
			fonction: $fonction
			telephone: $telephone
		) {
			id
			email
			client_name
			client_address
			contact_firstname
			contact_lastname
			fonction
			telephone
		}
	}
`;

const UPDATE_USER = gql`
	mutation(
		$id: ID!
		$email: String!
		$client_name: String!
		$client_address: String!
		$contact_firstname: String!
		$contact_lastname: String!
		$fonction: String!
		$telephone: String!
	) {
		user: updateUser(
			id: $id
			email: $email
			client_name: $client_name
			client_address: $client_address
			contact_firstname: $contact_firstname
			contact_lastname: $contact_lastname
			fonction: $fonction
			telephone: $telephone
		) {
			id
			email
			client_name
			client_address
			contact_firstname
			contact_lastname
			fonction
			telephone
		}
	}
`;

const DELETE_USER = gql`
	mutation($id: String!) {
		deleteUser(id: $id)
	}
`;

export {
	GET_USERS,
	CREATE_USER,
	UPDATE_USER,
	DELETE_USER,
};



// WEBPACK FOOTER //
// ./src/components/usersTable/queries.js